import Link from './link';
import Message from './message';

export default class Navbar {
  backgroundColor: string;
  banner?: Message;
  homeLink: Link | null;
  primaryLinks: Link[];
  secondaryLinks: Link[];
  socialLinks: Link[];
  socialTitle: string;
  textColor: string;

  constructor(props: any) {
    this.backgroundColor = props.backgroundColor;
    this.banner = props.banner ? new Message(props.banner) : undefined;
    this.homeLink = props.homeLink ? new Link(props.homeLink) : null;
    this.primaryLinks = props?.primaryLinksCollection?.items.map(
      (l: any) => new Link(l)
    );
    this.secondaryLinks = props?.secondaryLinksCollection?.items.map(
      (l: any) => new Link(l)
    );
    this.socialLinks = props?.socialLinksCollection?.items.map(
      (l: any) => new Link(l)
    );
    this.socialTitle = props.socialTitle;
    this.textColor = props.textColor;
  }
}
